import { useEffect, useState, type ReactNode } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export function OnboardingGate({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!user) {
      setChecked(true);
      return;
    }

    // Don't redirect if already on onboarding
    if (location.pathname === "/onboarding") {
      setChecked(true);
      return;
    }

    // Allow bypass when navigating from onboarding (e.g. filling a step)
    const params = new URLSearchParams(location.search);
    if (params.get("from") === "onboarding") {
      setChecked(true);
      return;
    }

    let cancelled = false;

    supabase
      .from("profiles")
      .select("onboarding_completed")
      .eq("user_id", user.id)
      .single()
      .then(({ data, error }) => {
        if (cancelled) return;
        // If no profile exists yet (e.g. OAuth race condition) or onboarding not completed, redirect
        if (error || !data || (data as any).onboarding_completed === false) {
          navigate("/onboarding", { replace: true });
        }
        setChecked(true);
      });

    return () => { cancelled = true; };
  }, [user, location.pathname, location.search, navigate]);

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  return <>{children}</>;
}
